import React, {Component} from 'react'
import * as actions from '../../actions'
import {connect} from 'react-redux'
import EkoDataTable from '../../components/elements/EkoDataTable'
import {toastr} from 'react-redux-toastr'
import AddCompanyUserRole from './AddCompanyUserRole'
import moment from 'moment'
import HelperContainer from '../../util/HelperContainer'

import Util from "../../util/Util";
import Api from '../../util/Api'
//import EkoToastrError from '../../components/elements/EkoToastrError'
import {FETCH_INVITATIONS} from '../../actions/types'
import {EkoFormButton} from "../../components/elements/EkoForm";
import AccountLockModal from "../../components/forms/AccountLockModal";
import EkoModal from "../../components/elements/EkoModal";

class CompanyUserRole extends Component {


    constructor(props) {
        super(props);

        this.state = {
            selectedRow: {},
            showUpdateModal: false,
            showInsertModal: false,
            showWorkingHoursModal: false,
            errors: {},
            lockShow: false,
            user: {},
            lock_before: null,
            validationFields: [],
            invitations: [], //table Item
            workingHoursTargetUser: null,
            workingHoursPolicy: null
        }

    }


    fetchInvitations() {
        this.props.fetchData("/invitation/list", FETCH_INVITATIONS);
    }

    componentWillMount() {
        this.fetchInvitations();

        this.setState({
            user: JSON.parse(localStorage.getItem('user'))
        })

        Api.get('/company/lock-before', (res) => {
            const lockBefore = res.lock_before;

            this.setState({
                lock_before: lockBefore
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.invitations) {
            this.setState({invitations: nextProps.invitations});
        }

    }


    openUpdate(selectedRow) {
        var self = this;
        const id = selectedRow.id;
        Api.get('/invitation/getId/' + id,
            function (response) {
                console.log(response);
                let formData = {}
                formData.companyUserRole = HelperContainer.filterObject(response.invitation);
                self.setState({
                    showInsertModal: true,
                    errors: {},
                    formData: formData
                });
            })


    }

    onDelete(selectedRow) {
        const self = this;
        Api.delete("/invitation/" + selectedRow.id, function (response, err) {
            if (response) {
                self.fetchInvitations();
                toastr.success('Başarılı', 'Başarıyla Silindi');
            }
            else toastr.error('Hata', err.message);
        })
        /*  let newData = Sugar.Array.filter(this.props.companyUserRoless,function(object){
              return (object.id!==selectedRow.id);
          });
          this.props.updateFetchedData(FETCH_SUPPLIERS,{companyUserRoless:newData});*/
    }


    onSave(formData, formFields) {
        this.fetchInvitations();
        this.setState({showInsertModal: false, formData: false});
    }

    toggleAccountLock = () => {
        this.setState((prevState) => ({
            lockShow: !prevState.lockShow
        }))
    }


    saveLockBefore = (lockBefore) => this.setState({
        lock_before: lockBefore
    })

    getDefaultWorkingHoursPolicy() {
        return {
            enabled: false,
            excludeOwner: true,
            days: {
                1: { enabled: true, start: "09:00", end: "18:00" },
                2: { enabled: true, start: "09:00", end: "18:00" },
                3: { enabled: true, start: "09:00", end: "18:00" },
                4: { enabled: true, start: "09:00", end: "18:00" },
                5: { enabled: true, start: "09:00", end: "18:00" },
                6: { enabled: false, start: "09:00", end: "18:00" },
                7: { enabled: false, start: "09:00", end: "18:00" }
            }
        }
    }
    updateWorkingHoursPolicy = (nextPolicy) => {
        this.setState({ workingHoursPolicy: nextPolicy });
    }
    updateWorkingHoursDay = (dayKey, patch) => {
        const policy = this.state.workingHoursPolicy || this.getDefaultWorkingHoursPolicy();
        const days = policy.days || {};
        const current = days[dayKey] || { enabled: false, start: "09:00", end: "18:00" };
        const nextPolicy = {
            ...policy,
            days: {
                ...days,
                [dayKey]: { ...current, ...patch },
            },
        };
        this.updateWorkingHoursPolicy(nextPolicy);
    }
    openWorkingHours = (row) => {
        const userId = row && row.user_id;
        if (!userId) {
            toastr.error("Hata", "Kullanıcı davetiyeyi kabul etmeden bu işlem yapılamaz");
            return;
        }
        this.setState({ showWorkingHoursModal: true, workingHoursTargetUser: userId, workingHoursPolicy: this.getDefaultWorkingHoursPolicy() });
        Api.get(`/company/workingHoursGet/${userId}`, (response) => {
            if (response && response.result == 1 && response.policy_json) {
                try {
                    const parsed = JSON.parse(response.policy_json);
                    if (parsed) this.setState({ workingHoursPolicy: { ...this.getDefaultWorkingHoursPolicy(), ...parsed, days: { ...this.getDefaultWorkingHoursPolicy().days, ...(parsed.days || {}) } } });
                } catch (e) {}
            }
        });
    }
    closeWorkingHours = () => {
        this.setState({ showWorkingHoursModal: false, workingHoursTargetUser: null });
    }
    saveWorkingHours = () => {
        const userId = this.state.workingHoursTargetUser;
        const policy = this.state.workingHoursPolicy || this.getDefaultWorkingHoursPolicy();
        const payload = {
            user_id: userId,
            working_hours_policy: {
                enabled: policy.enabled === true,
                excludeOwner: policy.excludeOwner === true,
                days: policy.days || {}
            }
        };
        Api.post("/company/workingHoursUpdate", payload, (response, postErrors) => {
            if (response && response.result == 1) {
                toastr.success("Başarılı", "Çalışma saatleri güncellendi");
                this.closeWorkingHours();
            } else {
                toastr.error("Hata", "Çalışma saatleri güncellenemedi");
            }
            if (postErrors) {
                this.setState({ errors: postErrors });
            }
        });
    }

    render() {
        return (
            <div>
                <a style={{"bottom": "6px", "position": "relative", "color": "grey"}}
                   onClick={Util.backButton.bind(this, "/dashboard")}><i className="fa fa-arrow-left"></i> Geri Dön</a>


                {this.state.user && this.state.user.is_owner ?
                    <AccountLockModal saveLockBefore={this.saveLockBefore} lockBefore={this.state.lock_before}
                                      showModal={this.state.lockShow} toggle={this.toggleAccountLock}/> : null}


                <AddCompanyUserRole
                    showModal={this.state.showInsertModal}
                    formData={this.state.formData}
                    onSave={this.onSave.bind(this)}
                    onCancel={() => {
                        this.setState({showInsertModal: false})
                    }}
                    errors={this.state.errors}
                />

                {this.state.user && this.state.user.is_owner ?
                    <div className="pull-right" style={{
                        marginTop: 10,
                        marginRight: 10
                    }}>
                        <EkoFormButton disabled={this.state.lock_before === null}
                                       isLoading={this.state.lock_before === null} onClick={this.toggleAccountLock}
                                       className={'btn btn-default'}
                                       label={this.state.lock_before ? 'Hesap Kilitli' : 'Hesabı Kitle'}/>
                        {this.state.lock_before ? <h5>
                            <small>{moment(this.state.lock_before).format('DD/MM/YYYY')} tarihinden öncesi
                                kilitli.</small>
                        </h5> : null}

                    </div> : null
                }

                <EkoDataTable
                    openInsert={() => {
                        this.setState({showInsertModal: true, formData: false})
                    }}
                    openUpdate={this.openUpdate.bind(this)}
                    onDelete={this.onDelete.bind(this)}
                    onWorkingHours={this.openWorkingHours.bind(this)}
                    data={this.props.invitations}
                    name={"invitation"}>


                </EkoDataTable>
                <EkoModal
                    showModal={this.state.showWorkingHoursModal}
                    onHide={this.closeWorkingHours}
                    bsSize={"lg"}
                >
                    <div className="row" style={{ padding: 10 }}>
                        <div className="col-md-3">
                            <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 6 }}>
                                Kısıtlama
                            </div>
                            <select
                                className="form-control"
                                value={this.state.workingHoursPolicy && this.state.workingHoursPolicy.enabled ? 1 : 0}
                                onChange={(e) =>
                                    this.updateWorkingHoursPolicy({
                                        ...(this.state.workingHoursPolicy || this.getDefaultWorkingHoursPolicy()),
                                        enabled: parseInt(e.target.value, 10) === 1,
                                    })
                                }
                            >
                                <option value={0}>Kapalı</option>
                                <option value={1}>Açık</option>
                            </select>
                        </div>
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                            <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 8 }}>
                                Haftalık Çizelge
                            </div>
                            <div style={{ overflowX: "auto" }}>
                                <table className="table table-bordered" style={{ background: "#fff" }}>
                                    <thead>
                                    <tr>
                                        <th style={{ width: 160 }}>Gün</th>
                                        <th style={{ width: 50 }}>Aktif</th>
                                        <th style={{ width: 160 }}>Başlangıç</th>
                                        <th style={{ width: 160 }}>Bitiş</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {[
                                        { key: 1, label: "Pazartesi" },
                                        { key: 2, label: "Salı" },
                                        { key: 3, label: "Çarşamba" },
                                        { key: 4, label: "Perşembe" },
                                        { key: 5, label: "Cuma" },
                                        { key: 6, label: "Cumartesi" },
                                        { key: 7, label: "Pazar" },
                                    ].map((d) => {
                                        const rule = (this.state.workingHoursPolicy && this.state.workingHoursPolicy.days && this.state.workingHoursPolicy.days[d.key]) || {};
                                        return (
                                            <tr key={d.key}>
                                                <td>{d.label}</td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={rule.enabled === true}
                                                        onChange={(e) =>
                                                            this.updateWorkingHoursDay(d.key, {
                                                                enabled: e.target.checked,
                                                            })
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        type="time"
                                                        value={rule.start || "09:00"}
                                                        onChange={(e) =>
                                                            this.updateWorkingHoursDay(d.key, {
                                                                start: e.target.value,
                                                            })
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        type="time"
                                                        value={rule.end || "18:00"}
                                                        onChange={(e) =>
                                                            this.updateWorkingHoursDay(d.key, {
                                                                end: e.target.value,
                                                            })
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-12" style={{ textAlign: "right" }}>
                            <button className="btn btn-default" onClick={this.closeWorkingHours}>Kapat</button>
                            <button className="btn btn-primary" style={{ marginLeft: 8 }} onClick={this.saveWorkingHours}>Kaydet</button>
                        </div>
                    </div>
                </EkoModal>
            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        invitations: state.data.invitations

    };
}

export default connect(mapStateToProps, actions)(CompanyUserRole);
